import React from 'react';
import { colorFades } from '../../../../../../Export/Resume/data/colorThemes';
import {
  Input as InputWrapper,
  PlaceHolder,
  Children,
  RightTools,
} from '../../../../../../UI/Editor/EditSpace/EditorPane/RenderContent/arrayItems';
import getWordSelectionDoubleClick from '../utils/getWordSelectionDoubleClick';
import OtherTools from './otherTools';
import Tools from './tools';
import { SAFARI } from '../../../../../../../../../utility/enums/browsers';
import { fnBrowserDetect } from '../../../../../../../../../utility/browsers';

const Input = (props) => {
  const {
    currentNodeType,
    nodeProps: { editor, node, children, isFocused, isSafari },
    userPreferences,
    placeHolder,
    stopDrag,
    showRatings,
    sectionKey,
    formatType,
    statusBarRef,
    mostUsedToolSetRef,
    rolesCount,
  } = props;
  const {
    value: { focusBlock },
  } = editor;

  let active;
  if (userPreferences) {
    ({
      colorPalette: { active },
    } = userPreferences);
  }

  const ratingBG = active && colorFades[active].base.rgba(0.15);
  return (
    <InputWrapper
      nodeType={currentNodeType}
      rating={node.data.get('rating')}
      ratingBG={ratingBG}
      isFocused={isFocused}
      onMouseDown={() =>
        !isFocused && fnBrowserDetect() !== SAFARI && editor.focus()
      }
      showRatings={(showRatings && showRatings[sectionKey]) || false}
      data-testid={`${currentNodeType}_input`}
    >
      <Children
        onMouseDown={(e) => {
          stopDrag();
          if (e.detail === 2) {
            getWordSelectionDoubleClick({ editor });
          }
          if (e.detail >= 3) {
            e.preventDefault();
            e.stopPropagation();
            editor.moveToRangeOfNode(focusBlock);
          }
        }}
        nodeType={currentNodeType}
        isFocused={isFocused}
      >
        {children}
      </Children>
      {!node.text && (
        <PlaceHolder nodeType={currentNodeType} contentEditable={false}>
          {placeHolder}
        </PlaceHolder>
      )}

      <RightTools
        isSafari={isSafari}
        nodeType={currentNodeType}
        contentEditable={false}
        isFocused={isFocused}
      >
        <Tools
          editor={editor}
          node={node}
          currentNodeType={currentNodeType}
          stopDrag={stopDrag}
          formatType={formatType}
          isFocused={isFocused}
          contentEditable={false}
          statusBarRef={statusBarRef}
          mostUsedToolSetRef={mostUsedToolSetRef}
          rolesCount={rolesCount}
        />
        {currentNodeType !== 'hobbies_and_interests' && (
          <OtherTools
            node={node}
            editor={editor}
            showRatings={(showRatings && showRatings[sectionKey]) || false}
            isFocused={isFocused}
          />
        )}
      </RightTools>
    </InputWrapper>
  );
};
export default Input;
